module.exports = __webpack_public_path__ + "img/stock7.a72a7aad.png";